jQuery.event.special.touchstart = {
  setup: function (_, ns, handle) {
    if (ns.includes("noPreventDefault")) {
      this.addEventListener("touchstart", handle, { passive: false });
    } else {
      this.addEventListener("touchstart", handle, { passive: true });
    }
  },
};

jQuery.event.special.touchmove = {
  setup: function (_, ns, handle) {
    if (ns.includes("noPreventDefault")) {
      this.addEventListener("touchmove", handle, { passive: false });
    } else {
      this.addEventListener("touchmove", handle, { passive: true });
    }
  },
};

jQuery.event.special.wheel = {
  setup: function (_, ns, handle) {
    if (ns.includes("noPreventDefault")) {
      this.addEventListener("wheel", handle, { passive: false });
    } else {
      this.addEventListener("wheel", handle, { passive: true });
    }
  },
};
/**** Main menu ****/
var $navigationWrapper = $(".navigation-wrapper");
var mobileMenuFocusSelector =
  'a[href], area[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

function isMobileMenuOpen() {
  return $("body").hasClass("navi-open") && window.innerWidth < 992;
}

function getMobileMenuFocusableElements() {
  return $navigationWrapper.find(mobileMenuFocusSelector).filter(":visible");
}

function focusMobileMenuCloseButton() {
  var $closeButton = $navigationWrapper.find(".close-mobile-navi:visible").first();

  if ($closeButton.length) {
    $closeButton.trigger("focus");
  }
}

$(".navi-icon-container").on("click", function () {
  $(".navi-icon-container").toggleClass("is-active");
  $(".header-container").toggleClass("navi-open");
  $navigationWrapper.toggleClass("navi-open");
  $("body").toggleClass("navi-open");

  if (isMobileMenuOpen()) {
    setTimeout(focusMobileMenuCloseButton, 0);
  }
});

$(".close-mobile-navi").on("click", function (e) {
  e.preventDefault();
  $(".navi-icon-container").removeClass("is-active");
  $(".header-container").removeClass("navi-open");
  $navigationWrapper.removeClass("navi-open");
  $("body").removeClass("navi-open");
});

function closeLevel1Submenu($level1) {
  $level1.removeClass("open");
}

function closeOtherLevel1Submenus($currentLevel1) {
  $("li.level1.sublevels.open").each(function () {
    var $level1 = $(this);

    if (!$level1.is($currentLevel1)) {
      closeLevel1Submenu($level1);
    }
  });
}

$(".show-more").on("click", function (e) {
  e.preventDefault();
  var $level1 = $(this).closest("li.level1");
  var isOpen = $level1.hasClass("open");

  closeOtherLevel1Submenus($level1);

  if (isOpen) {
    closeLevel1Submenu($level1);
    return;
  }

  $level1.addClass("open");
});

$("li.level1.sublevels").on("focusout", function () {
  if (isMobileMenuOpen()) {
    return;
  }

  var $level1 = $(this);

  setTimeout(function () {
    if ($level1.has(document.activeElement).length) {
      return;
    }

    closeLevel1Submenu($level1);
  }, 0);
});

$(document).on("focusin", function () {
  if (isMobileMenuOpen()) {
    return;
  }

  $("li.level1.sublevels.open").each(function () {
    var $level1 = $(this);

    if (!$level1.has(document.activeElement).length) {
      closeLevel1Submenu($level1);
    }
  });
});

$(document).on("keydown", function (e) {
  if (isMobileMenuOpen() && e.key === "Tab") {
    var $focusableElements = getMobileMenuFocusableElements();

    if (!$focusableElements.length) {
      e.preventDefault();
      return;
    }

    var firstElement = $focusableElements.get(0);
    var lastElement = $focusableElements.get($focusableElements.length - 1);

    if (e.shiftKey && document.activeElement === firstElement) {
      e.preventDefault();
      $(lastElement).trigger("focus");
      return;
    }

    if (!e.shiftKey && document.activeElement === lastElement) {
      e.preventDefault();
      $(firstElement).trigger("focus");
      return;
    }
  }

  if (e.key !== "Escape") {
    return;
  }

  $("li.level1.sublevels.open").each(function () {
    closeLevel1Submenu($(this));
  });
});

/**** Main menu end ****/

/**** Back to top ****/
var $backtop = $(".backtop");

function toggleBacktop() {
  var scrollTop = $(window).scrollTop();
  var docHeight = $(document).height();
  var winHeight = $(window).height();
  if (scrollTop + winHeight >= docHeight - 2) {
    $backtop.fadeIn(200);
  } else {
    $backtop.fadeOut(200);
  }
}

toggleBacktop();

$(window).on("scroll", toggleBacktop);
$(window).on("resize", toggleBacktop);

$backtop.on("click", function () {
  $("html, body").animate({ scrollTop: 0 }, 1200, "swing");
});
/**** Back to top end ****/

var $lang = $("#lang");
var $langTrigger = $lang.find(".lang-active");

function closeLangDropdown() {
  $lang.removeClass("open");
  $langTrigger.attr("aria-expanded", "false");
}

function openLangDropdown() {
  $lang.addClass("open");
  $langTrigger.attr("aria-expanded", "true");
}

function toggleLangDropdown() {
  if ($lang.hasClass("open")) {
    closeLangDropdown();
  } else {
    openLangDropdown();
  }
}

$(document).on("click", "#lang .lang-active", function (e) {
  e.preventDefault();
  e.stopPropagation();
  toggleLangDropdown();
});

$(document).on("keydown", "#lang .lang-active", function (e) {
  var isEnter = e.key === "Enter" || e.keyCode === 13;
  var isSpace = e.key === " " || e.keyCode === 32;

  if (!isEnter && !isSpace) return;

  e.preventDefault();
  toggleLangDropdown();
});

$(document).on("click", function (e) {
  if (!$(e.target).closest("#lang").length) {
    closeLangDropdown();
  }
});

$(document).on("click", "#lang .lang-navi a", function () {
  closeLangDropdown();
});

$(document).on("keydown", function (e) {
  if (e.key === "Escape" && $lang.hasClass("open")) {
    closeLangDropdown();
    $langTrigger.focus();
  }
});
